module.exports = __webpack_public_path__ + "static/nav-logo-noborder-40c24138d38fb1bc42f4288fdfb77285.svg";